import React from "react";
import { MetroFilter } from "./MetroFilters";

interface MetroFilterWrapperProps {
  metros: string[];
  onApply: (metros: string[]) => void;
}

export const MetroFilterWrapper: React.FC<MetroFilterWrapperProps> = ({
  metros,
  onApply,
}) => {
  return (
    <div className="service-metro">
      <p className="service-metro-title">Metro Filter:</p>
      <MetroFilter metros={metros} onApply={onApply} />
    </div>
  );
};
